import { render } from "./cvView-2.vue?vue&type=template&id=42961069&scoped=true"
import script from "./cvView-2.vue?vue&type=script&lang=js"
export * from "./cvView-2.vue?vue&type=script&lang=js"

import "./cvView-2.vue?vue&type=style&index=0&id=42961069&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42961069"]])

export default __exports__